import React from 'react'
import styled from 'styled-components'
import { Page, PageContent, PageHeader, SettingsButton } from '../../common'
import { Liquidities } from './Liquidities'
import { PoolNavigation } from './PoolNavigation'

export function Pool() {
  return (
    <Page>
      <PageContent>
        <PageHeader label="Pool" />
        <PoolNavigationStyled />
        <Liquidities />
        <SettingsButton />
      </PageContent>
    </Page>
  )
}

const PoolNavigationStyled = styled(PoolNavigation)`
  margin-bottom: 20px;
`
